import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../lib/auth'

export default function RedirectIfAuthed({ children }) {
  const { user, initializing } = useAuth()

  if (initializing) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>Loading…</div>
      </div>
    )
  }

  if (user) {
    return <Navigate to="/account" replace />
  }

  return children
}
